import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-ne",
  "use": "icon-icon-ne-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-ne\">\n  <path fill=\"#0db02b\" d=\"M0 0h512v512H0z\" />\n  <path fill=\"#fff\" d=\"M0 0h512v341.3H0z\" />\n  <path fill=\"#e05206\" d=\"M0 0h512v170.7H0z\" />\n  <circle cx=\"256\" cy=\"256\" r=\"72.5\" fill=\"#e05206\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol